import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';

const getMarketingNewsFeatures = (state) => resolveProp('profile.data.mktgNewsFeatures', state);
const getMarketingProducts = (state) => resolveProp('profile.data.mktgProducts', state);
const getMarketingTips = (state) => resolveProp('profile.data.mktgTips', state);
const getMarketingResearchInfo = (state) => resolveProp('profile.data.mktgResearchInfo', state);
const getMarketingPreferencesVersion = (state) => resolveProp('profile.data.mktgPreferencesVersion', state);
const getMarketingRtcEmails = (state) => resolveProp('profile.data.mktgRtcEmails', state);
const getMarketingCoachingEmails = (state) => resolveProp('profile.data.mktgCoachingEmails', state);

export default createSelector(
    getMarketingNewsFeatures,
    getMarketingProducts,
    getMarketingTips,
    getMarketingResearchInfo,
    getMarketingPreferencesVersion,
    getMarketingRtcEmails,
    getMarketingCoachingEmails,
    (
        mktgNewsFeatures,
        mktgProducts,
        mktgTips,
        mktgResearchInfo,
        mktgPreferencesVersion,
        mktgRtcEmails,
        mktgCoachingEmails,
    ) => ({
        mktgNewsFeatures,
        mktgProducts,
        mktgTips,
        mktgResearchInfo,
        mktgPreferencesVersion,
        mktgRtcEmails,
        mktgCoachingEmails,
    }),
);
